import React from 'react';
import './Summit_title.css';
import VisibilitySensor from 'react-visibility-sensor';

const Summit_title = () => {
    return (
        <VisibilitySensor partialVisibility={true}>
            {({ isVisible }) =>
                <section className="summit_title">
                    <div className="container">
                        <p className={`${isVisible ? 'visible' : 'invisible'} summit_title--left`}>global</p>
                        <p className={`${isVisible ? 'visible' : 'invisible'} summit_title--right`}>ui/ux</p>
                        <p className={`${isVisible ? 'visible' : 'invisible'} summit_title--left2`}>summit</p>
                    </div>
                </section>
            }
        </VisibilitySensor>
    );
};

export default Summit_title;